import React from 'react'
import { createRoot } from 'react-dom/client'
import { createDependencies } from './app/dependencies.js'
import { createApplication } from './app/application-shell.js'
import { createProvider } from './infrastructure/api/provider-factory.js'
import { Workbench } from './components/Workbench.jsx'
import './styles.css'

const storage = globalThis.localStorage
let config = {}
try { config = JSON.parse(storage?.getItem?.('iwb_web_cfg') || '{}') } catch {}
const app = createApplication(createDependencies({ provider: createProvider({ config }) }))

createRoot(document.getElementById('root')).render(<Workbench app={app} />)
